import { FC, useEffect } from 'react';
import { useAtomValue } from 'jotai';
import LoadMore from '~/components/load-more';
import { $CurrentPOIPosts } from '@poi/shared/current-poi-posts';
import { ArticleCard } from '~/components/article-card';
import { Loaders } from 'shared/constant';
import { $POIPostsLoadmore } from 'shared/atoms/poi';
import { useRouteLoader } from '@lemon8/web-app-shared/ssr';
import { Loading } from '~/components/loading';
import { useTranslation } from 'react-i18next';

export const POIPosts: FC = () => {
  const { t } = useTranslation();
  const { items, hasMore, sessionImprId } = useAtomValue($CurrentPOIPosts);

  const loader = useRouteLoader(
    Loaders.POI.POIPostsLoadmore,
    {
      session_impr_id: sessionImprId,
    },
    {
      atomFamilies: {
        $POIPostsLoadmore,
      },
    },
  );

  useEffect(() => {
    loader.load();
  }, []);

  const loadData = () => {
    loader.load();
    return Promise.resolve({ data: [] });
  };

  return (
    <LoadMore
      loadData={loadData}
      isEnd={!hasMore}
      endText={t('no_more_items')}
      distanceToLoad={500}
      render={() => (
        <>
          {items.map((item) => (
            <ArticleCard key={item.groupId} article={item} />
          ))}
          {hasMore && <Loading variant="ball" />}
          <footer />
        </>
      )}
    />
  );
};
